import { Icon } from "../components/Icon.js";

export function ConflictsPage() {
  return <ComingSoon
    icon="warning"
    title="Conflicts"
    blurb="When two devices change the same event at the same time, you'll resolve it here. Activates once the desktop app is live and events start syncing."
  />;
}

function ComingSoon({ icon, title, blurb }: { icon: string; title: string; blurb: string }) {
  return (
    <div className="bg-surface-container border border-outline-variant rounded-xl p-xl flex flex-col items-center text-center gap-md min-h-[420px] justify-center">
      <Icon name={icon} className="text-primary-fixed-dim/60" style={{ fontSize: "56px" }} />
      <h1 className="text-display-xl text-on-background">{title}</h1>
      <p className="max-w-md text-body-base text-on-surface-variant">{blurb}</p>
      <span className="font-mono text-label-xs uppercase tracking-widest text-on-surface-variant border border-outline-variant rounded-lg px-3 py-1.5 mt-2">
        Coming after Phase 1 sync
      </span>
    </div>
  );
}
